<template>
  <div class="px-6 px-lg-14 pt-6 pt-lg-10">
    <!-- Top Bar -->
      <!-- <div class="top-buttons">
        
        <button class="filterButton"
          @click="importFiles()"
        >
          <img width='70%' height='auto' src="../assets/img/svg/icons/import.svg">
        </button>
        <button class="addButton"
          @click="
            (createmode = true),
              (createCustomerPopup = true),
              resetEditedCustomer()
          "
        >
          <img width='70%' height='auto' src="../assets/img/svg/icons/add.svg">
        </button>
      </div> -->
    <v-btn
      class="addButton"
      fab
      dark
      large
      elevation="0"
      color="black"
      @click="resetEditedCustomer(),openDrawer(true)"
    >
      <img width='35%' height='auto' src="../assets/img/svg/icons/add.svg">
    </v-btn>
    


    <div class="mx-0 pb-6 pb-lg-10 row align-items-end">
        <div class="text-h4 text-uppercase" style="display: inline-block;">{{ $t("tenants") }}<div class="text-body-1 ml-1" style="display: inline-block;">({{totalElements}})</div></div>
        
    </div> 
    <div class="row mx-0 justify-content-between">
      <div class="col">

      <!-- ADD SORT ?? -->


      </div>
      <div class="col text-right">

        <!-- <v-btn 
          :ripple="false"
          hide-details="auto"
          @click="inviteDialog = true"
          class="rounded-0 mt-2"
          outlined v-if="rightGlobalAccess" color="">
          <v-icon class="mr-1">mdi-account-plus-outline</v-icon> {{$t('invite_user')}}</v-btn> -->
      </div>

    </div>


    <div class="page-content">
      <v-simple-table class="customertable">
        <thead>
          <tr>
            <th class="align-bottom" @click="sort = 'name', order = !order,page = 1, fetchCustomers()">
              {{ $t("name") }} <v-icon v-show="sort == 'name' && order" >fas fa-chevron-down</v-icon><v-icon v-show="sort == 'name' && !order" >fas fa-chevron-up</v-icon>
            </th>
            <th class="align-bottom">
              {{ $t("users") }} 
              <!-- <v-icon v-show="sort == 'userLicenses' && order" >fas fa-chevron-down</v-icon><v-icon v-show="sort == 'userLicenses' && !order" >fas fa-chevron-up</v-icon> -->
            </th>
            <th class="align-bottom">
              {{ $t("valid_licenses") }} 
              <!-- <v-icon v-show="sort == 'deviceLicenses' && order" >fas fa-chevron-down</v-icon><v-icon v-show="sort == 'deviceLicenses' && !order" >fas fa-chevron-up</v-icon> -->
            </th>
            <th class="align-bottom col-2">Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr class="rowform" v-if="createmode">
            <td>
              <v-text-field
              hide-details="auto"
              v-model="editedCustomer.name"
              class="findingsinput font-24px"
              dense
              >
                <template v-slot:label>

                </template>
              </v-text-field>
            </td>
            <!-- <td>
              <v-text-field
              hide-details="auto"
              v-model="editedCustomer.userLicenses"
              class="findingsinput font-24px"
              type="number"
              :rules="numberInputGreaterThanZeroRule"
              dense
              >
                <template v-slot:label>

                </template>
              </v-text-field>
            </td>
            <td>
              <v-text-field
              hide-details="auto"
              v-model="editedCustomer.deviceLicenses"
              class="findingsinput font-24px"
              type="number"
              :rules="numberInputGreaterThanZeroRule"
              dense
              >
                <template v-slot:label>

                </template>
              </v-text-field>
            </td> -->
            <td>
              <button class="actionButton" @click="createCustomer()">
                <v-icon color="white">fa-thin fa-check</v-icon>
              </button>
              
            
              <button class="actionButton float-right" @click="createmode = false,resetEditedCustomer();">
                <v-icon class="whiteicon scale-137" >$trash</v-icon>
              </button>
            </td>
          </tr>
          <tr v-for="customer in customers" :key="customer.id">
            <td>{{ customer.name }}</td>
            <!-- <td class="editform" v-if="editmode && customer.id == editedCustomer.id">
              <v-text-field
              hide-details="auto"
              v-model="editedCustomer.userLicenses"
              class="findingsinput font-24px"
              type="number"
              :value="customer.userLicenses"
              :rules="numberInputGreaterThanZeroRule"
              dense
              >
                <template v-slot:label>

                </template>
              </v-text-field>
            </td>
            <td v-else>{{ customer.userLicenses }}</td>
            <td class="editform" v-if="editmode && customer.id == editedCustomer.id">
              <v-text-field
              hide-details="auto"
              v-model="editedCustomer.deviceLicenses"
              class="findingsinput font-24px"
              type="number"
              :value="customer.deviceLicenses"
              :rules="numberInputGreaterThanZeroRule"
              dense
              >
                <template v-slot:label>

                </template>
              </v-text-field>
            </td>
            <td v-else>{{ customer.deviceLicenses }}</td> -->
            <td> {{customer.userCount}}</td>
            <td>{{customer.validLicenseCount}}</td>
            <td >
              <!--
              <v-icon class="mr-5" color="black" elevation="2" @click=" (createmode = false), (createCustomerPopup = true), getEditedCustomer(customer) " >fas fa-pencil-alt</v-icon>
              <v-icon class="mr-5" color="black" elevation="2" @click=" showConfirmation($t('confirm_delete_customer'), function () { deleteCustomer(customer.id); }) " >fas fa-trash-alt</v-icon>
              -->

              <!-- Download Invoices Button with Year Dropdown (Super Admin Only) -->
              <v-menu  offset-y v-if="rightGlobalAccess" @input="fetchAvailableYearsForCustomer(customer.id, $event)">
                <template v-slot:activator="{ on, attrs }">
                  <button
                    class="actionButton"
                    v-bind="attrs"
                    v-on="on"
                    :title="$t('download_invoices')"
                  >
                    <v-icon color="black" size="28">mdi-folder-download-outline</v-icon>
                  </button>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="loadingYears[customer.id]"
                    disabled
                  >
                    <v-list-item-title>
                      <v-progress-circular indeterminate size="16" width="2"></v-progress-circular>
                      {{ $t('loading') }}...
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-else-if="!customerYears[customer.id] || customerYears[customer.id].length === 0"
                    disabled
                  >
                    <v-list-item-title>{{ $t('no_invoices_found') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-else
                    v-for="year in customerYears[customer.id]"
                    :key="year"
                    @click="downloadInvoicesForCustomer(customer.id, customer.name, year)"
                  >
                    <v-list-item-title>{{ year }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <button class="actionButton"
              @click="getEditedCustomer(customer),(createmode = false),openDrawer(false,customer)"
            >

                <v-icon color="black" size="28">mdi-pencil</v-icon>
            </button>

            <button class="actionButton "
              @click=" showConfirmation($t('confirm_delete_customer'), function () { deleteCustomer(customer.id); }) "
            >
              <v-icon color="black" size="28">mdi-trash-can-outline</v-icon>
            </button>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div style="position:absolute; bottom: 100px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>


      <!-- Create Customer Popup -->
      <v-dialog v-model="createCustomerPopup" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span v-show="createmode" class="headline">{{
              $t("create_element", { name: $t("customer") })
            }}</span>
            <span v-show="!createmode" class="headline">{{
              $t("edit_element", { name: editedCustomer.name })
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :label="$t('designation') + '*'"
                    v-model="editedCustomer.name"
                    :rules="rules"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    :label="$t('userLicenses') + '*'"
                    v-model="editedCustomer.userLicenses"
                    type="number"
                    :rules="numberInputGreaterThanZeroRule"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    :label="$t('deviceLicenses') + '*'"
                    v-model="editedCustomer.deviceLicenses"
                    type="number"
                    :rules="numberInputGreaterThanZeroRule"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" text @click="createCustomerPopup = false">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              v-show="createmode"
              color="primary"
              text
              @click="createCustomer()"
              :disabled="!customerModelIsValid"
            >
              {{ $t("save") }}
            </v-btn>
            <v-btn
              v-show="!createmode"
              color="primary"
              text
              @click="editCustomer()"
              :disabled="!customerModelIsValid"
            >
              {{ $t("save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Confirmation Popup -->
      <v-dialog v-model="confirmation.shown" width="500">
        <v-card>
          <v-card-title>
            {{ $t("security_question") }}
          </v-card-title>

          <v-card-text>
            {{ confirmation.text }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="confirmation.shown = false">
              {{ $t("no") }}
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="
                confirmation.action();
                confirmation.shown = false;
              "
            >
              {{ $t("yes") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </div>
  </div>
</template>

<script>


export default {

    components: {
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 20,
      totalElements: null,
      isFetchingMoreCustomers: false,
      sort: null,
      order: true,
      routes: {
        customers: "api/customers",
        import: "api/import"
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],

      inviteDialog: false,
      isValid:false,
      inviteEmail: "",

      numberInputGreaterThanZeroRule: [
        value => !!value || this.$t('required'),
        value => value > 0 || this.$t('greater_than_zero')
      ],
      rules: [(value) => !!value || this.$t("required")],
      customers: [],
      editedCustomer: {
        id: null,
        name: "",
      },
      confirmation: {
        text: "",
        action: null,
        shown: false,
      },
      createCustomerPopup: false,
      createmode: false,
      editmode: false,
      rightGlobalAccess: false,
      customerYears: {}, // Stores available years for each customer
      loadingYears: {}, // Tracks loading state for each customer
    };
  },

  computed: {
    customerModelIsValid() {
      return this.editedCustomer.name.length > 0 && this.editedCustomer.userLicenses > 0 && this.editedCustomer.deviceLicenses > 0
    }
  },

  mounted() {
    this.fetchMe();
    this.fetchCustomers();
  },

  methods: {
    async infiniteScrolling(entries, observer, isIntersecting) {
      if (!isIntersecting) return;
      if (this.isFetchingMoreCustomers) return;
      if (this.page >= this.totalPages) return;

      this.isFetchingMoreCustomers = true;

      try {
        const nextPage = this.page + 1;

        const response = await this.$axios.get(this.routes.customers, {
          params: {
            sort: this.sort,
            order: this.order ? "ASC" : "DESC",
            page: nextPage - 1,
            size: this.ElementPerPage,
          },
        });

        const newCustomers = response.data.content || [];
        const existingIds = new Set(this.customers.map(c => c.id));
        const uniqueNewCustomers = newCustomers.filter(c => !existingIds.has(c.id));

        this.customers.push(...uniqueNewCustomers);
        this.page = nextPage;
        this.totalPages = response.data.totalPages;
        this.totalElements = response.data.totalElements;
      } catch (err) {
        this.onError(err);
      } finally {
        this.isFetchingMoreCustomers = false;
      }
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + this.$t(err.response.data.message));
      } else {
        console.error(err);
      }
    },
    async fetchMe() {
      var _this = this;
      await this.$axios
        .get("api/me")
        .then(function (response) {
          _this.me = response.data;
          _this.rightGlobalAccess = _this.hasRight("GlobalAccess");
        })
        .catch(this.onError);
    },
    hasRight(right) {
      if (this.me.rights.includes(right)) return true;
      if (this.me.role != null) {
        return this.me.role.rights.includes(right);
      }
      return false;
    },

    isTenantAdmin() {
      // A Tenant Admin has ManageTenantUsers or ManageTenant rights but NOT GlobalAccess
      return (this.hasRight("ManageTenantUsers") || this.hasRight("ManageTenant")) &&
             !this.hasRight("GlobalAccess");
    },
    fetchCustomers() {
      this.page = 1;
      this.isFetchingMoreCustomers = false;

      var _this = this;
      this.$axios
        .get(this.routes.customers, {
          params: {
            sort: this.sort,
            order: this.order ? "ASC":"DESC",
            page: this.page - 1,
            size: this.ElementPerPage,
          },
        })
        .then(function (response) {
          _this.customers = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.totalElements = response.data.totalElements;
        })
        .catch(this.onError)
        .finally(showLoadingCircle(false));
    },
    updatePage() {
      this.fetchCustomers();
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchCustomers();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchCustomers();
    },
    createCustomer() {
      var _this = this;
      this.$axios
        .post(this.routes.customers, this.editedCustomer)
        .then(function (response) {
          _this.$noty.success('<i class="fas fa-check-circle mr-3"></i>' + _this.$t("customer_created"));
          var customer = response.data;
          _this.resetEditedCustomer();
          _this.createCustomerPopup = false;
          _this.createmode = false;
          _this.fetchCustomers();
        })
        .catch(this.onError);
    },
    editCustomer() {
      var _this = this;
      this.$axios
        .put(this.routes.customers, this.editedCustomer)
        .then(function (response) {
          var customer = response.data;
          _this.$noty.success('<i class="fas fa-check-circle mr-3"></i>' + _this.$t("customer_updated"));
          _this.resetEditedCustomer();
          _this.createCustomerPopup = false;
          _this.fetchCustomers();
        })
        .catch(this.onError);
    },
    deleteCustomer(customerid) {
      var _this = this;
      this.$axios
        .delete("api/customers/" + customerid)
        .then(function (response) {
          _this.$noty.success(_this.$t("customer_deleted"));
          _this.fetchCustomers();
        })
        .catch(this.onError);
    },
    openDrawer(createmode,tenant = null){
      this.$emit("showTenantForm", { createmode: createmode,tenant: tenant,sendInvitationMail:true});
    },

    resetEditedCustomer() {
      this.editedCustomer = {
        id: null,
        name: "",
        // userLicenses: 1,
        // deviceLicenses: 2,
      };
    },
    getEditedCustomer(customer) {
      this.editedCustomer = {
        id: customer.id,
        name: customer.name,
        // userLicenses: customer.userLicenses,
        // deviceLicenses: customer.deviceLicenses,
      };
    },

    importFiles() {
      showLoadingCircle(true);
      var _this = this;
      this.$axios
        .get(this.routes.import)
        .then(function (response) {
          _this.$noty.success(response.data);
        })
        .catch(this.onError)
        .finally(() => {
          showLoadingCircle(false);
        });
    },

    showConfirmation(text, action) {
      this.confirmation.text = text;
      this.confirmation.action = action;
      this.confirmation.shown = true;
    },

    async fetchAvailableYearsForCustomer(customerId, menuOpen) {
      // Only fetch when menu opens (menuOpen === true)
      if (!menuOpen || this.customerYears[customerId]) {
        return; // Already fetched or menu is closing
      }

      // Set loading state
      this.$set(this.loadingYears, customerId, true);

      try {
        // Fetch all receipts for this customer (with invoices only)
        const response = await this.$axios.get(`/api/payment/customer/${customerId}/receipts`, {
          params: {
            page: 0,
            size: 1000 // Get all receipts
          }
        });

        const receipts = response.data.content || response.data;

        // Extract unique years from receipt creation dates
        const yearsSet = new Set();
        receipts.forEach(receipt => {
          if (receipt.createdAt) {
            const year = new Date(receipt.createdAt).getFullYear();
            yearsSet.add(year);
          }
        });

        // Convert to sorted array (newest first)
        const years = Array.from(yearsSet).sort((a, b) => b - a);

        // Store the years for this customer
        this.$set(this.customerYears, customerId, years);
      } catch (error) {
        console.error('Error fetching available years:', error);
        this.$set(this.customerYears, customerId, []);
      } finally {
        this.$set(this.loadingYears, customerId, false);
      }
    },

    async downloadInvoicesForCustomer(customerId, customerName, year) {
      try {
        const response = await this.$axios.get(
          `/api/payment/customer/${customerId}/receipts/download-year/${year}`,
          {
            responseType: 'blob'
          }
        );

        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoices_${customerName}_${year}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$noty.success('<i class="fas fa-check mr-3"></i>' + this.$t("yearly_invoices_downloaded"));
      } catch (error) {
        // Handle blob response errors (e.g., 404 when no invoices found)
        if (error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const json = JSON.parse(text);
            if (error.response.status === 404) {
              this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + this.$t("no_invoices_for_year"));
              return;
            }
          } catch (e) {
            // If parsing fails, fall through to default error handling
          }
        }
        this.onError(error);
      }
    },
    SendInvitation(){
      const form = this.$refs.inviteForm;
      var _this = this;
      if (form.validate()) {

       const email = {
        email: this.inviteEmail
       }
       this.$axios
        .post("api/invitations",email)
        .then(function (response) {
          if(response.status === 200){
            _this.$noty.success('<i class="fas fa-check-circle mr-3"></i> ' + _this.$t('Invitation_send'));
          }
        })
        .catch(this.onError);
        this.inviteDialog = false;
        this.inviteEmail = null;
      }
      
    }
  },
};
</script>